export default "__VITE_ASSET__ceXSkRkM__"